export default function Footer() {
  const scrollToAnchor = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-foreground-600">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div>
            <h3 className="text-foreground-100 font-bold font-heading text-lg mb-4">
              80s电影网
            </h3>
            <p className="text-xs leading-relaxed mb-4">
              高清在线看免费不卡影视平台，蓝光画质搭配极速播引擎，点开即播不缓冲，每日更新热门影片。
            </p>
          </div>

          <div>
            <h4 className="text-foreground-300 font-semibold text-sm mb-4">快速导航</h4>
            <div className="space-y-2">
              {[
                { label: '热门榜单', id: 'ranking' },
                { label: '精选专题', id: 'carousel' },
                { label: '分类索引', id: 'index' },
                { label: '精彩花絮', id: 'media' },
              ].map((item) => (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToAnchor(item.id);
                  }}
                  className="block text-xs hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-foreground-300 font-semibold text-sm mb-4">热门分类</h4>
            <div className="space-y-2">
              {['动作片', '科幻片', '悬疑片', '动画片', '纪录片'].map((cat) => (
                <a
                  key={cat}
                  href="#index"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToAnchor('index');
                  }}
                  className="block text-xs hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-foreground-300 font-semibold text-sm mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-700">合作伙伴信息即将上线，敬请期待。</p>
          </div>
        </div>

        <div className="border-t border-background-700/50 pt-8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-700">
            &copy; 2018-2026 80s电影网. 高清在线看免费不卡，蓝光画质极速播。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => { e.preventDefault(); scrollToAnchor('hero'); }} className="text-xs text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">首页</a>
            <a href="#faq" onClick={(e) => { e.preventDefault(); scrollToAnchor('faq'); }} className="text-xs text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToAnchor('contact'); }} className="text-xs text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}